import React from 'react';

import {
  Wrapper,
  ContentWrapper,
  ImageContainer,
  TextContainer,
} from './NoData.styles';

export const NoData = () => {
  return (
    <Wrapper>
      <ContentWrapper>
        <ImageContainer />
        <TextContainer>
          You have no published reports yet.
          <br />
          All reports created and published in Power BI
          <br /> will be listed in this page
        </TextContainer>
      </ContentWrapper>
    </Wrapper>
  );
};
